import React, { useState, useEffect } from "react"
import _ from "lodash"
import { localizeNum, tryParseFloat } from "data/lib/numbers"
import { InputText_s } from "styles/input-styles"

interface NumberInputProps {
  id?: string
  attrs?: Function,
  field: string,
  persist: Function,
  readPrecision?: number,
  writePrecision?: number,
  className?: string,
  value: any,
  disabled?: boolean
  disabledText?: string
  respectFocus?: boolean
}

const NumberInput = (props: NumberInputProps) => {
  const [value, setValue] = useState<string>(props.value ? localizeNum(props.value , props.readPrecision) : "")
  const [hasFocus, setHasFocus] = useState<boolean>(false)

  function update(e:React.FormEvent):void {
    let formVal = (e.target as HTMLInputElement).value
    let val = formVal !== "" ? tryParseFloat(formVal, props.writePrecision) : null
    setValue(localizeNum(val , props.readPrecision))
    props.persist(props.field, val, e)
  }

  useEffect(() => {
    if (props.respectFocus && hasFocus) return
    if (!_.isNil(props.value)) {
      setValue(localizeNum(props.value, props.readPrecision));
    } else {
      setValue("");
    }
  }, [props, props.respectFocus && hasFocus])

  const attrs = (props.attrs && !props.disabled && props.attrs(props.field)) || {}

  return (
    <InputText_s
      id={props.id}
      disabled={props.disabled}
      type="text"
      className={props.className}
      value={props.disabled && props.disabledText ? props.disabledText : value}
      onChange={e => setValue((e.target as HTMLInputElement).value)}
      onKeyDown={e => {
        switch(e.key) {
          case "Enter":
            update(e)
            break
        }
      }}
      onFocus={_e => {
        setHasFocus(true)
        !_.isNil(props.value) && props.value !== "" ? setValue(tryParseFloat(props.value, props.writePrecision)) : props.value
      }}
      onBlur={e => {
        setHasFocus(false);
        update(e)
      }}
      {...attrs}/>
  )
}

export default NumberInput
